module.exports = __webpack_public_path__ + "img/medal_silver.f24ccaeb.svg";